import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { PopupWrapper } from './PopupContainer.style';
import { assertNever } from 'src_common/common/assertNever';
import { HelpAndContactPopup } from './HelpAndContactPopup';
import { MarketingNotificationsPopupView } from 'src/domains/layouts/webview/components/popups/MarketingNotificationsPopup';
import { GameModal } from 'src/domains/casino/shared/Components';
import { AgreeOrCancelPopup } from './agreeOrCancelPopup/AgreeOrCancelPopup';
import { RealityCheckPopup } from 'src/domains/layouts/webview/components/popups/realityCheckPopup/RealityCheckPopup';
import { RealityCheckNewValueConfirmationPopup } from './realityCheckNewValueConfirmationPopup/RealityCheckNewValueConfirmationPopup';
import { MultipleSlotsPopup } from 'src/domains/casino/webview/CasinoGames';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { useCommon } from 'src/domains/common/Common';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';
import { XtremePushModal } from 'src/domains/layouts/webview/components/xtremePush/xtremePushModal/XtremePushModal';

export const PopupContainer = observer('PopupContainer', (): JSX.Element | null => {
    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);
    const appCasinoState = AppCasinoState.get(common);

    const { popupState } = appLayoutsState;
    const { popupForView } = popupState;

    if (popupForView === null) {
        return null;
    }

    if (popupForView.type === 'helpAndContact') {
        return (
            <PopupWrapper>
                <HelpAndContactPopup popup={popupForView} />
            </PopupWrapper>
        );
    }

    if (popupForView.type === 'multipleSlotsPopup') {
        return (
            <PopupWrapper>
                <MultipleSlotsPopup />
            </PopupWrapper>
        );
    }

    if (popupForView.type === 'gameModal') {
        return <GameModal appCasinoState={appCasinoState} />;
    }

    if (popupForView.type === 'marketingNotificationsPopup') {
        return <MarketingNotificationsPopupView />;
    }

    if (popupForView.type === 'popupDeleteCard') {
        return <AgreeOrCancelPopup popupForView={popupForView} />;
    }

    if (popupForView.type === 'popupRealityCheck') {
        return <RealityCheckPopup />;
    }

    if (popupForView.type === 'popupRealityCheckNewValueConfirmation') {
        return <RealityCheckNewValueConfirmationPopup />;
    }

    if (popupForView.type === 'xtreme') {
        return <XtremePushModal />;
    }

    return assertNever('PopupContainer', popupForView);
});
